<ng-template
  #tpl
  let-hide
>
  <div
    class="popover"
  >
    @if (infoHtml) {
      <div
        [innerHtml]="infoHtml"
      ></div>
    } @else {
      <div
        [innerText]="infoText"
      ></div>
    }

    <div
      class="icon"
    >
      <i class="fa-kit fa-moti"></i>
    </div>
  </div>
</ng-template>

<div
  class="contents"

>
  <ng-content></ng-content>
</div>
